/*! js-cookie v3.0.0 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      value = converter.write(value, key);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie = key + '=' + value + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        if (value[0] === '"') {
          value = value.slice(1, -1);
        }

        try {
          var foundKey = defaultConverter.read(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));
/*!
 * jQuery & Zepto Lazy - v1.7.10
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 *
 * $("img.lazy").lazy();
 */

;(function(window, undefined) {
    "use strict";

    // noinspection JSUnresolvedVariable
    /**
     * library instance - here and not in construct to be shorter in minimization
     * @return void
     */
    var $ = window.jQuery || window.Zepto,

    /**
     * unique plugin instance id counter
     * @type {number}
     */
    lazyInstanceId = 0,

    /**
     * helper to register window load for jQuery 3
     * @type {boolean}
     */    
    windowLoaded = false;

    /**
     * make lazy available to jquery - and make it a bit more case-insensitive :)
     * @access public
     * @type {function}
     * @param {object} settings
     * @return {LazyPlugin}
     */
    $.fn.Lazy = $.fn.lazy = function(settings) {
        return new LazyPlugin(this, settings);
    };

    /**
     * helper to add plugins to lazy prototype configuration
     * @access public
     * @type {function}
     * @param {string|Array} names
     * @param {string|Array|function} [elements]
     * @param {function} loader
     * @return void
     */
    $.Lazy = $.lazy = function(names, elements, loader) {
        // make second parameter optional
        if ($.isFunction(elements)) {
            loader = elements;
            elements = [];
        }

        // exit here if parameter is not a callable function
        if (!$.isFunction(loader)) {
            return;
        }

        // make parameters an array of names to be sure
        names = $.isArray(names) ? names : [names];
        elements = $.isArray(elements) ? elements : [elements];

        var config = LazyPlugin.prototype.config,
            forced = config._f || (config._f = {});

        // add the loader plugin for every name
        for (var i = 0, l = names.length; i < l; i++) {
            if (config[names[i]] === undefined || $.isFunction(config[names[i]])) {
                config[names[i]] = loader;
            }
        }

        // add forced elements loader
        for (var c = 0, a = elements.length; c < a; c++) {
            forced[elements[c]] = names[0];
        }
    };

    /**
     * contains all logic and the whole element handling
     * is packed in a private function outside class to reduce memory usage, because it will not be created on every plugin instance
     * @access private
     * @type {function}
     * @param {LazyPlugin} instance
     * @param {object} config
     * @param {object|Array} items
     * @param {object} events
     * @param {string} namespace
     * @return void
     */
    function _executeLazy(instance, config, items, events, namespace) {
        /**
         * a helper to trigger the 'onFinishedAll' callback after all other events
         * @access private
         * @type {number}
         */
        var _awaitingAfterLoad = 0,

        /**
         * visible content width
         * @access private
         * @type {number}
         */
        _actualWidth = -1,

        /**
         * visible content height
         * @access private
         * @type {number}
         */
        _actualHeight = -1,

        /**
         * determine possibly detected high pixel density
         * @access private
         * @type {boolean}
         */
        _isRetinaDisplay = false, 

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _afterLoad = 'afterLoad',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _load = 'load',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _error = 'error',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _img = 'img',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _src = 'src',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _srcset = 'srcset',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _sizes = 'sizes',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _backgroundImage = 'background-image';

        /**
         * initialize plugin
         * bind loading to events or set delay time to load all items at once
         * @access private
         * @return void
         */
        function _initialize() {
            // detect actual device pixel ratio
            // noinspection JSUnresolvedVariable
            _isRetinaDisplay = window.devicePixelRatio > 1;

            // prepare all initial items
            items = _prepareItems(items);

            // if delay time is set load all items at once after delay time
            if (config.delay >= 0) {
                setTimeout(function() {
                    _lazyLoadItems(true);
                }, config.delay);
            }

            // if no delay is set or combine usage is active bind events
            if (config.delay < 0 || config.combined) {
                // create unique event function
                events.e = _throttle(config.throttle, function(event) {
                    // reset detected window size on resize event
                    if (event.type === 'resize') {
                        _actualWidth = _actualHeight = -1;
                    }

                    // execute 'lazy magic'
                    _lazyLoadItems(event.all);
                });

                // create function to add new items to instance
                events.a = function(additionalItems) {
                    additionalItems = _prepareItems(additionalItems);
                    items.push.apply(items, additionalItems);
                };

                // create function to get all instance items left
                events.g = function() {
                    // filter loaded items before return in case internal filter was not running until now
                    return (items = $(items).filter(function() {
                        return !$(this).data(config.loadedName);
                    }));
                };

                // create function to force loading elements
                events.f = function(forcedItems) {
                    for (var i = 0; i < forcedItems.length; i++) {
                        // only handle item if available in current instance
                        // use a compare function, because Zepto can't handle object parameter for filter
                        // var item = items.filter(forcedItems[i]);
                        /* jshint loopfunc: true */
                        var item = items.filter(function() {
                            return this === forcedItems[i];
                        });

                        if (item.length) {
                            _lazyLoadItems(false, item);   
                        }
                    }
                };

                // load initial items
                _lazyLoadItems();

                // bind lazy load functions to scroll and resize event
                // noinspection JSUnresolvedVariable
                $(config.appendScroll).on('scroll.' + namespace + ' resize.' + namespace, events.e);
            }
        }

        /**
         * prepare items before handle them
         * @access private
         * @param {Array|object|jQuery} items
         * @return {Array|object|jQuery}
         */
        function _prepareItems(items) {
            // fetch used configurations before loops
            var defaultImage = config.defaultImage,
                placeholder = config.placeholder,
                imageBase = config.imageBase,
                srcsetAttribute = config.srcsetAttribute,
                loaderAttribute = config.loaderAttribute,
                forcedTags = config._f || {};

            // filter items and only add those who not handled yet and got needed attributes available
            items = $(items).filter(function() {
                var element = $(this),
                    tag = _getElementTagName(this);

                return !element.data(config.handledName) && 
                       (element.attr(config.attribute) || element.attr(srcsetAttribute) || element.attr(loaderAttribute) || forcedTags[tag] !== undefined);
            })

            // append plugin instance to all elements
            .data('plugin_' + config.name, instance);

            for (var i = 0, l = items.length; i < l; i++) {
                var element = $(items[i]),
                    tag = _getElementTagName(items[i]),
                    elementImageBase = element.attr(config.imageBaseAttribute) || imageBase;

                // generate and update source set if an image base is set
                if (tag === _img && elementImageBase && element.attr(srcsetAttribute)) {
                    element.attr(srcsetAttribute, _getCorrectedSrcSet(element.attr(srcsetAttribute), elementImageBase));
                }

                // add loader to forced element types
                if (forcedTags[tag] !== undefined && !element.attr(loaderAttribute)) {
                    element.attr(loaderAttribute, forcedTags[tag]);
                }

                // set default image on every element without source
                if (tag === _img && defaultImage && !element.attr(_src)) {
                    element.attr(_src, defaultImage);
                }

                // set placeholder on every element without background image
                else if (tag !== _img && placeholder && (!element.css(_backgroundImage) || element.css(_backgroundImage) === 'none')) {
                    element.css(_backgroundImage, "url('" + placeholder + "')");
                }
            }

            return items;
        }

        /**
         * the 'lazy magic' - check all items
         * @access private
         * @param {boolean} [allItems]
         * @param {object} [forced]
         * @return void
         */
        function _lazyLoadItems(allItems, forced) {
            // skip if no items where left
            if (!items.length) {
                // destroy instance if option is enabled
                if (config.autoDestroy) {
                    // noinspection JSUnresolvedFunction
                    instance.destroy();
                }

                return;
            }

            var elements = forced || items,
                loadTriggered = false,
                imageBase = config.imageBase || '',
                srcsetAttribute = config.srcsetAttribute,
                handledName = config.handledName;

            // loop all available items
            for (var i = 0; i < elements.length; i++) {
                // item is at least in loadable area
                if (allItems || forced || _isInLoadableArea(elements[i])) {
                    var element = $(elements[i]),
                        tag = _getElementTagName(elements[i]),
                        attribute = element.attr(config.attribute),
                        elementImageBase = element.attr(config.imageBaseAttribute) || imageBase,
                        customLoader = element.attr(config.loaderAttribute);

                        // is not already handled 
                    if (!element.data(handledName) &&
                        // and is visible or visibility doesn't matter
                        (!config.visibleOnly || element.is(':visible')) && (
                        // and image source or source set attribute is available
                        (attribute || element.attr(srcsetAttribute)) && (
                            // and is image tag where attribute is not equal source or source set
                            (tag === _img && (elementImageBase + attribute !== element.attr(_src) || element.attr(srcsetAttribute) !== element.attr(_srcset))) ||
                            // or is non image tag where attribute is not equal background
                            (tag !== _img && elementImageBase + attribute !== element.css(_backgroundImage))
                        ) ||
                        // or custom loader is available
                        customLoader))
                    {
                        // mark element always as handled as this point to prevent double handling
                        loadTriggered = true;
                        element.data(handledName, true);

                        // load item
                        _handleItem(element, tag, elementImageBase, customLoader);
                    }
                }
            }

            // when something was loaded remove them from remaining items
            if (loadTriggered) {
                items = $(items).filter(function() {
                    return !$(this).data(handledName);
                });
            }
        }

        /**
         * load the given element the lazy way
         * @access private
         * @param {object} element
         * @param {string} tag
         * @param {string} imageBase
         * @param {function} [customLoader]
         * @return void
         */
        function _handleItem(element, tag, imageBase, customLoader) {
            // increment count of items waiting for after load
            ++_awaitingAfterLoad;

            // extended error callback for correct 'onFinishedAll' handling
            var errorCallback = function() {
                _triggerCallback('onError', element);
                _reduceAwaiting();

                // prevent further callback calls
                errorCallback = $.noop;
            };

            // trigger function before loading image
            _triggerCallback('beforeLoad', element);

            // fetch all double used data here for better code minimization
            var srcAttribute = config.attribute,
                srcsetAttribute = config.srcsetAttribute,
                sizesAttribute = config.sizesAttribute,
                retinaAttribute = config.retinaAttribute,
                removeAttribute = config.removeAttribute,
                loadedName = config.loadedName,
                elementRetina = element.attr(retinaAttribute);

            // handle custom loader
            if (customLoader) {
                // on load callback
                var loadCallback = function() {
                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(config.loaderAttribute);
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // remove item from waiting queue and possibly trigger finished event
                    // it's needed to be asynchronous to run after filter was in _lazyLoadItems
                    setTimeout(_reduceAwaiting, 1);

                    // prevent further callback calls
                    loadCallback = $.noop;
                };

                // bind error event to trigger callback and reduce waiting amount
                element.off(_error).one(_error, errorCallback)

                // bind after load callback to element
                .one(_load, loadCallback);

                // trigger custom loader and handle response
                if (!_triggerCallback(customLoader, element, function(response) {
                    if(response) {
                        element.off(_load);
                        loadCallback();
                    }
                    else {
                        element.off(_error);
                        errorCallback();
                    }
                })) {
                    element.trigger(_error);
                }
            }

            // handle images
            else {
                // create image object
                var imageObj = $(new Image());

                // bind error event to trigger callback and reduce waiting amount
                imageObj.one(_error, errorCallback)

                // bind after load callback to image
                .one(_load, function() {
                    // remove element from view
                    element.hide();

                    // set image back to element
                    // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                    if (tag === _img) {
                        element.attr(_sizes, imageObj.attr(_sizes))
                               .attr(_srcset, imageObj.attr(_srcset))
                               .attr(_src, imageObj.attr(_src));
                    }
                    else {
                        element.css(_backgroundImage, "url('" + imageObj.attr(_src) + "')");
                    }

                    // bring it back with some effect!
                    element[config.effect](config.effectTime);

                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(srcAttribute + ' ' + srcsetAttribute + ' ' + retinaAttribute + ' ' + config.imageBaseAttribute);

                        // only remove 'sizes' attribute, if it was a custom one
                        if (sizesAttribute !== _sizes) {
                            element.removeAttr(sizesAttribute);
                        }
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // cleanup image object
                    imageObj.remove();

                    // remove item from waiting queue and possibly trigger finished event
                    _reduceAwaiting();
                });

                // set sources
                // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                var imageSrc = (_isRetinaDisplay && elementRetina ? elementRetina : element.attr(srcAttribute)) || '';
                imageObj.attr(_sizes, element.attr(sizesAttribute))
                        .attr(_srcset, element.attr(srcsetAttribute))
                        .attr(_src, imageSrc ? imageBase + imageSrc : null);

                // call after load even on cached image
                imageObj.complete && imageObj.trigger(_load); // jshint ignore : line
            }
        }

        /**
         * check if the given element is inside the current viewport or threshold
         * @access private
         * @param {object} element
         * @return {boolean}
         */
        function _isInLoadableArea(element) {
            var elementBound = element.getBoundingClientRect(),
                direction    = config.scrollDirection,
                threshold    = config.threshold,
                vertical     = // check if element is in loadable area from top
                               ((_getActualHeight() + threshold) > elementBound.top) &&
                               // check if element is even in loadable are from bottom
                               (-threshold < elementBound.bottom),
                horizontal   = // check if element is in loadable area from left
                               ((_getActualWidth() + threshold) > elementBound.left) &&
                               // check if element is even in loadable area from right
                               (-threshold < elementBound.right);

            if (direction === 'vertical') {
                return vertical;
            }
            else if (direction === 'horizontal') {
                return horizontal;
            }

            return vertical && horizontal;
        }

        /**
         * receive the current viewed width of the browser
         * @access private
         * @return {number}
         */
        function _getActualWidth() {
            return _actualWidth >= 0 ? _actualWidth : (_actualWidth = $(window).width());
        }

        /**
         * receive the current viewed height of the browser
         * @access private
         * @return {number}
         */
        function _getActualHeight() {
            return _actualHeight >= 0 ? _actualHeight : (_actualHeight = $(window).height());
        }

        /**
         * get lowercase tag name of an element
         * @access private
         * @param {object} element
         * @returns {string}
         */
        function _getElementTagName(element) {
            return element.tagName.toLowerCase();
        }

        /**
         * prepend image base to all srcset entries
         * @access private
         * @param {string} srcset
         * @param {string} imageBase
         * @returns {string}
         */
        function _getCorrectedSrcSet(srcset, imageBase) {
            if (imageBase) {
                // trim, remove unnecessary spaces and split entries
                var entries = srcset.split(',');
                srcset = '';

                for (var i = 0, l = entries.length; i < l; i++) {
                    srcset += imageBase + entries[i].trim() + (i !== l - 1 ? ',' : '');
                }
            }

            return srcset;
        }

        /**
         * helper function to throttle down event triggering
         * @access private
         * @param {number} delay
         * @param {function} callback
         * @return {function}
         */
        function _throttle(delay, callback) {
            var timeout,
                lastExecute = 0;

            return function(event, ignoreThrottle) {
                var elapsed = +new Date() - lastExecute;

                function run() {
                    lastExecute = +new Date();
                    // noinspection JSUnresolvedFunction
                    callback.call(instance, event);
                }

                timeout && clearTimeout(timeout); // jshint ignore : line

                if (elapsed > delay || !config.enableThrottle || ignoreThrottle) {
                    run();
                }
                else {
                    timeout = setTimeout(run, delay - elapsed);
                }
            };
        }

        /**
         * reduce count of awaiting elements to 'afterLoad' event and fire 'onFinishedAll' if reached zero
         * @access private
         * @return void
         */
        function _reduceAwaiting() {
            --_awaitingAfterLoad;

            // if no items were left trigger finished event
            if (!items.length && !_awaitingAfterLoad) {
                _triggerCallback('onFinishedAll');
            }
        }

        /**
         * single implementation to handle callbacks, pass element and set 'this' to current instance
         * @access private
         * @param {string|function} callback
         * @param {object} [element]
         * @param {*} [args]
         * @return {boolean}
         */
        function _triggerCallback(callback, element, args) {
            if ((callback = config[callback])) {
                // jQuery's internal '$(arguments).slice(1)' are causing problems at least on old iPads
                // below is shorthand of 'Array.prototype.slice.call(arguments, 1)'
                callback.apply(instance, [].slice.call(arguments, 1));
                return true;
            }

            return false;
        }

        // if event driven or window is already loaded don't wait for page loading
        if (config.bind === 'event' || windowLoaded) {
            _initialize();
        }

        // otherwise load initial items and start lazy after page load
        else {
            // noinspection JSUnresolvedVariable
            $(window).on(_load + '.' + namespace, _initialize);
        }  
    }

    /**
     * lazy plugin class constructor
     * @constructor
     * @access private
     * @param {object} elements
     * @param {object} settings
     * @return {object|LazyPlugin}
     */
    function LazyPlugin(elements, settings) {
        /**
         * this lazy plugin instance
         * @access private
         * @type {object|LazyPlugin|LazyPlugin.prototype}
         */
        var _instance = this,

        /**
         * this lazy plugin instance configuration
         * @access private
         * @type {object}
         */
        _config = $.extend({}, _instance.config, settings),

        /**
         * instance generated event executed on container scroll or resize
         * packed in an object to be referenceable and short named because properties will not be minified
         * @access private
         * @type {object}
         */
        _events = {},

        /**
         * unique namespace for instance related events
         * @access private
         * @type {string}
         */
        _namespace = _config.name + '-' + (++lazyInstanceId);

        // noinspection JSUndefinedPropertyAssignment
        /**
         * wrapper to get or set an entry from plugin instance configuration
         * much smaller on minify as direct access
         * @access public
         * @type {function}
         * @param {string} entryName
         * @param {*} [value]
         * @return {LazyPlugin|*}
         */
        _instance.config = function(entryName, value) {
            if (value === undefined) {
                return _config[entryName];
            }

            _config[entryName] = value;
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * add additional items to current instance
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.addItems = function(items) {
            _events.a && _events.a($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * get all left items of this instance
         * @access public
         * @returns {object}
         */
        _instance.getItems = function() {
            return _events.g ? _events.g() : {};
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all items in loadable area right now
         * by default without throttle
         * @access public
         * @type {function}
         * @param {boolean} [useThrottle]
         * @return {LazyPlugin}
         */
        _instance.update = function(useThrottle) {
            _events.e && _events.e({}, !useThrottle); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force element(s) to load directly, ignoring the viewport
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.force = function(items) {
            _events.f && _events.f($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all available items right now
         * this call ignores throttling
         * @access public
         * @type {function}
         * @return {LazyPlugin}
         */
        _instance.loadAll = function() {
            _events.e && _events.e({all: true}, true); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * destroy this plugin instance
         * @access public
         * @type {function}
         * @return undefined
         */
        _instance.destroy = function() {
            // unbind instance generated events
            // noinspection JSUnresolvedFunction, JSUnresolvedVariable
            $(_config.appendScroll).off('.' + _namespace, _events.e);
            // noinspection JSUnresolvedVariable
            $(window).off('.' + _namespace);

            // clear events
            _events = {};

            return undefined;
        };

        // start using lazy and return all elements to be chainable or instance for further use
        // noinspection JSUnresolvedVariable
        _executeLazy(_instance, _config, elements, _events, _namespace);
        return _config.chainable ? elements : _instance;
    }

    /**
     * settings and configuration data
     * @access public
     * @type {object|*}
     */
    LazyPlugin.prototype.config = {
        // general
        name               : 'lazy',
        chainable          : true,
        autoDestroy        : true,
        bind               : 'load',
        threshold          : 500,
        visibleOnly        : false,
        appendScroll       : window,
        scrollDirection    : 'both',
        imageBase          : null,
        defaultImage       : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
        placeholder        : null,
        delay              : -1,
        combined           : false,

        // attributes
        attribute          : 'data-src',
        srcsetAttribute    : 'data-srcset',
        sizesAttribute     : 'data-sizes',
        retinaAttribute    : 'data-retina',
        loaderAttribute    : 'data-loader',
        imageBaseAttribute : 'data-imagebase',
        removeAttribute    : true,
        handledName        : 'handled',
        loadedName         : 'loaded',

        // effect
        effect             : 'show',
        effectTime         : 0,

        // throttle
        enableThrottle     : true,
        throttle           : 250,

        // callbacks
        beforeLoad         : undefined,
        afterLoad          : undefined,
        onError            : undefined,
        onFinishedAll      : undefined
    };

    // register window load event globally to prevent not loading elements
    // since jQuery 3.X ready state is fully async and may be executed after 'load' 
    $(window).on('load', function() {
        windowLoaded = true;
    });
})(window);
/*!
 * jQuery & Zepto Lazy - iFrame Plugin - v1.5
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 */
;(function($) {
    // load iframe content, like:
    // <iframe data-src="iframe.html"></iframe>
    //
    // enable content error check with:
    // <iframe data-src="iframe.html" data-error-detect="true"></iframe>
    $.lazy(['frame', 'iframe'], 'iframe', function(element, response) {
        var instance = this;

        if (element[0].tagName.toLowerCase() === 'iframe') {
            var srcAttr = 'data-src',
                errorDetectAttr = 'data-error-detect',
                errorDetect = element.attr(errorDetectAttr);

            // default way, just replace the 'src' attribute
            if (errorDetect !== 'true' && errorDetect !== '1') {
                // set iframe source
                element.attr('src', element.attr(srcAttr));

                // remove attributes
                if (instance.config('removeAttribute')) {
                    element.removeAttr(srcAttr + ' ' + errorDetectAttr);
                }
            }

            // extended way, even check if the document is available
            else {
                $.ajax({
                    url: element.attr(srcAttr),
                    dataType: 'html',
                    crossDomain: true,
                    xhrFields: {withCredentials: true},

                    /**
                     * success callback
                     * @access private
                     * @param {*} content
                     * @return {void}
                     */
                    success: function(content) {
                        // set responded data to element's inner html
                        element.html(content)

                        // change iframe src
                        .attr('src', element.attr(srcAttr));

                        // remove attributes
                        if (instance.config('removeAttribute')) {
                            element.removeAttr(srcAttr + ' ' + errorDetectAttr);
                        }
                    },

                    /**
                     * error callback
                     * @access private
                     * @return {void}
                     */
                    error: function() {
                        // pass error state to lazy
                        // use response function for Zepto
                        response(false);
                    }
                });
            }
        }

        else {
            // pass error state to lazy
            // use response function for Zepto
            response(false);
        }
    });
})(window.jQuery || window.Zepto);

jQuery('iframe').Lazy();

(function($) {
    /**
     * Menu script
     */
    class PP_Menu {
        constructor() {
            this.initState();
            this.initEvents();
            this.initRWD();
        }
    
        initState() {
            this.win = $(window);
            this.menuWrapper = $('.site-header');
            this.menuIcon = this.menuWrapper.find('.menu-toggle');
            this.menu = this.menuWrapper.find('#site-navigation');
            this.menuItemSubmenu = this.menuWrapper.find('.menu-item-has-children');
            this.mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
            this.desktopViewport = window.matchMedia("screen and (min-width: 1025px)");
            this.searchBtn = this.menuWrapper.find('.menu-search-btn');
            this.menuLinks = $('#menu-main a');
        }
    
        initEvents() {
            this.menuItemSubmenu.append( "<span class='arrow'></span>" );
    
            $(window).on('scroll', () => {
                let positionY = this.win.scrollTop();
    
                if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
                    this.menuWrapper.addClass('is-fixed');
                    return;
                }
    
                if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
                    this.menuWrapper.removeClass('is-fixed');
                }
            });
    
            if (this.menuIcon.length) {
                this.menuIcon.on('click', e => {
                    e.preventDefault();
                    this.menu.toggleClass('is-active');
                    this.menuIcon.toggleClass('is-active');
                    $(document.body).toggleClass('no-scroll');
    
                    setTimeout(() => {
                        this.menu.toggleClass('is-showing');
                    }, 150);
                });
    
                this.menuLinks.on('click', e => {
                    if ($(window).width() <= 1024) {
                        this.menuIcon.trigger('click');
                    }
                });
            }
        }
    
        initRWD () {
            if(this.mobileViewport.matches) {
                this.initMobileViewportBehaviour();
            }
    
            if(this.desktopViewport.matches) {
                this.initDesktopViewportBehaviour();
            }
    
            this.mobileViewport.addListener(mq => {
                if (mq.matches) {
                    this.initMobileViewportBehaviour();
                }
            });
    
            this.desktopViewport.addListener(mq => {
                if (mq.matches) {
                    this.initDesktopViewportBehaviour()
                }
            });
        }
    
        initMobileViewportBehaviour () {
            setTimeout(() => {
                this.menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');
    
                this.menuSubmenuToggle.each(function(i, item) {
                    $(item).on('click', (e) => {
                        $(item).parent().toggleClass('is-active');
                    });
                });
    
                this.searchBtn.insertBefore(this.menuIcon);
            }, 0);
        }
    
        initDesktopViewportBehaviour () {
            setTimeout(() => {
                this.searchBtn.insertBefore(this.menuWrapper.find('.menu-additional-cta'));
            }, 0);
        }
    }
    
    /**
     * UI elements
     */
    class PP_UI {
    	constructor() {
    		this.initSmoothScroll();
    		this.detectEdge();
    		this.initYTVideoWithCover();
    		this.initTextAccordion();
    		this.initCountDown();
    		this.initCountColumns();
        this.initFathomEvents();
    	}
    
    	initSmoothScroll () {
    		$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
    			if (
    				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
    				&&
    				location.hostname == this.hostname
    			) {
    				var target = $(this.hash);
    				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    				if (target.length) {
    					event.preventDefault();
    					$('html, body').animate({
    						scrollTop: target.offset().top - 100
    					}, 1000);
    				}
    			}
    		});
    	}
    
    	detectEdge () {
    		if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    			document.body.classList.add('browser--is-edge')
    		}
    	}
    
    	initYTVideoWithCover () {
    		let videos = $('.video-with-cover-image');
    
    		if (!videos.length) {
    			return;
    		}
    
    		for (let i = 0; i < videos.length; i++) {
    			let overlay = videos.eq(i);
    
    			videos.eq(i).on('click', e => {
    				e.preventDefault();
    				overlay.addClass('is-hidden');
    				overlay.parent().find('.video-block-media-wrapper').addClass('is-active');
    				let iframe = overlay.parent().find('iframe');
    
    				iframe.on('load', function () {
    					setTimeout(() => {
    						iframe[0].contentWindow.postMessage(JSON.stringify({
    						'event': 'command',
    						'func': 'playVideo',
    						'args': []
    						}), '*');
    					}, 500);
    				});
    
    				iframe.attr('src', iframe.attr('data-src'));
    			});
    		}
    	}
    
    	initTextAccordion () {
    		if ($(document.body).hasClass('js-ui-accordion-initialized')) {
    			return;
    		}
    
    		$(document.body).addClass('js-ui-accordion-initialized');
    
    		$(".js-accordion").each(function(i, item) {
    			$(item).find('.js-accordion-content').css('height', 0);
    
    			$(item).on("click", function () {
    				let item = $(this);
    				let contentWrapper = item.find('.js-accordion-content');
    				let contentText = item.find('.js-accordion-content > div');
    
    				item.toggleClass('active');
    				let newHeight = contentText.outerHeight();
    
    				if (item.hasClass('active')) {
    					contentWrapper.css('height', 0);
    
    					setTimeout(function() {
    						contentWrapper.css('height', newHeight + 'px');
    					}, 0);
    
    					setTimeout(function() {
    						contentWrapper.css('height', 'auto');
    					}, 500);
    				} else {
    					contentWrapper.css('height', newHeight + 'px');
    
    					setTimeout(function() {
    						contentWrapper.css('height', 0);
    					}, 0);
    				}
    			});
    		});
    	}
    
    	initCountDown () {
    		if (!$('.pp-timer-wrapper').length) {
    			return;
    		}
    
    		$('.pp-timer-wrapper').each((i, countdown) => {
    			let countdownElements = {
    				daysValue: $(countdown).find('.pp-timer-days-count'),
    				daysSuffix: $(countdown).find('.pp-timer-days-label'),
    				hoursValue: $(countdown).find('.pp-timer-hours-count'),
    				hoursSuffix: $(countdown).find('.pp-timer-hours-label'),
    				minutesValue: $(countdown).find('.pp-timer-minutes-count'),
    				minutesSuffix: $(countdown).find('.pp-timer-minutes-label'),
    				secondsValue: $(countdown).find('.pp-timer-seconds-count'),
    				secondsSuffix: $(countdown).find('.pp-timer-seconds-label'),
    			};
    
    			ppCalculateCountdown($(countdown), countdownElements);
    		});
    	}
    
    	initCountColumns () {
    		let columnsBlock = $('.wp-block-columns');
    
    		if (!columnsBlock.length) {
    			return;
    		}
    
    		for (let i = 0; i < columnsBlock.length; i++) {
    			columnsBlock.eq(i).attr('data-count', columnsBlock.eq(i).find('.wp-block-column').length);
        	}
    	}
    
      initFathomEvents () {
        let linksWithEvents = $('a[data-fathom-event]');
    
        for (let i = 0; i < linksWithEvents.length; i++) {
          let link = linksWithEvents.eq(i);
    
          if (link.attr('data-fathom-event')) {
            link.on('click', e => {
              let eventName = link.attr('data-fathom-event');
    
              if (fathom && eventName) {
                fathom.trackEvent(eventName.replace('&nbsp;', ''));
              }
            });
          }
        }
      }
    }
    
    function ppCalculateCountdown (countdown, countdownElements) {
    	let countTo = parseInt(countdown.attr('data-timestamp-utc'), 10) * 1000;
    	let currentTime = new Date().getTime();
    
        if (countTo - currentTime > 0) {
            let diff = countTo - currentTime;
            let days = Math.floor(diff / (24 * 60 * 60 * 1000));
            let hoursDiff = diff - (days * 24 * 60 * 60 * 1000);
            let hours = (Math.floor(hoursDiff / (60 * 60 * 1000))) % 24;
            let minutesDiff = hoursDiff - (hours * 60 * 60 * 1000);
            let minutes = (Math.floor(minutesDiff / (60 * 1000))) % 60;
    		let seconds = Math.floor((minutesDiff - (minutes * 60 * 1000)) / 1000);
            let daysSuffix = days === 1 ? 'dzień' : 'dni';
            let hoursSuffix = 'godzin';
            let minutesSuffix = 'minut';
    		let secondsSuffix = 'sekund';
    
            if (hours === 1) {
                hoursSuffix = 'godzina';
            } else if (hours === 2 || hours === 3 || hours === 4 || hours === 22 || hours === 23) {
                hoursSuffix = 'godziny';
            }
    
            if (minutes === 1) {
                minutesSuffix = 'minuta';
            } else if (
                minutes === 2 || minutes === 3 || minutes === 4 || 
                minutes === 22 || minutes === 23 || minutes === 24 || 
                minutes === 32 || minutes === 33 || minutes === 34 || 
                minutes === 42 || minutes === 43 || minutes === 44 || 
                minutes === 52 || minutes === 53 || minutes === 54
            ) {
                minutesSuffix = 'minuty';
            }
    
    		if (seconds === 1) {
                secondsSuffix = 'sekunda';
            } else if (
                seconds === 2 || seconds === 3 || seconds === 4 || 
                seconds === 22 || seconds === 23 || seconds === 24 || 
                seconds === 32 || seconds === 33 || seconds === 34 || 
                seconds === 42 || seconds === 43 || seconds === 44 || 
                seconds === 52 || seconds === 53 || seconds === 54
            ) {
                secondsSuffix = 'sekundy';
            }
    
    		countdownElements.daysValue.text(days);
    		countdownElements.daysSuffix.text(daysSuffix);
    		countdownElements.hoursValue.text(hours);
    		countdownElements.hoursSuffix.text(hoursSuffix);
    		countdownElements.minutesValue.text(minutes);
    		countdownElements.minutesSuffix.text(minutesSuffix);
    		countdownElements.secondsValue.text(seconds);
    		countdownElements.secondsSuffix.text(secondsSuffix);
    
            setTimeout(() => {
                ppCalculateCountdown (countdown, countdownElements);
            }, 1000);
        } else {
            countdown.find('.pp-timer').addClass('is-hidden');
    		countdown.find('.pp-timer-finished').removeClass('is-hidden');
        }
    }
    
    /**
     * Social sharing buttons script
     */
     class PP_SocialSharing {
      constructor() {
        if(!$('.post-sharing').length) {
          return;
        }
        this.initPopups();
      }
      initPopups() {
        $('.post-sharing-link').each(function(i, link) {
          $(link).on('click', function(e) {
            e.preventDefault();
            window.open($(link).attr('href'), 'Share this post', 'width=500,height=400,resizable=yes').focus();
          });
        });
      }
    }
    
    class PP_BlogCategories {
      constructor () {
        this.initEvents();
      }
    
      initEvents () {
        let wrapper = $('.blog-categories-list');
    
        if (!wrapper.length) {
          return;
        }
    
        let toggleButton = wrapper.find('.blog-categories-item-expand');
        let closeButton = wrapper.find('.blog-categories-item-close');
        
        toggleButton.on('click', e => {
          e.preventDefault();
          let hiddenItems = wrapper.find('.blog-categories-item.is-hidden');
          hiddenItems.addClass('is-not-visible').removeClass('is-hidden');
    
          setTimeout(() => {
            for (let i = 0; i < hiddenItems.length; i++) {
              let element = hiddenItems.eq(i);
              
              setTimeout(() => {
                element.removeClass('is-not-visible');
                element.addClass('is-now-displayed');
              }, i * 25);
            }
          }, 0);
    
          setTimeout(() => {
            toggleButton.addClass('is-hidden');
            closeButton.removeClass('is-hidden');
          }, 0);
        });
    
        closeButton.on('click', e => {
          e.preventDefault();
          let itemsToHide = wrapper.find('.blog-categories-item.is-now-displayed');
          itemsToHide.removeClass('is-now-displayed');
    
          setTimeout(() => {
            for (let i = itemsToHide.length; i > 0; i--) {
              let element = itemsToHide.eq(i);
              
              setTimeout(() => {
                element.addClass('is-not-visible');
              }, (itemsToHide.length - i) * 25);
            }
    
            setTimeout(() => {
              itemsToHide.addClass('is-hidden').removeClass('is-not-visible');
              toggleButton.removeClass('is-hidden');
              closeButton.addClass('is-hidden');
            }, itemsToHide.length * 25);
          }, 0);
        });
      }
    }
    /**
     * UI elements
     */
    class PP_Graduates {
    	constructor () {
            if (!$('.graduates-search-input').length) {
                return;
            }
    
            this.initState();
    		this.initEvents();
    	}
    
    	initState () {
    		this.UI = {
                input: $('.graduates-search-input'),
                items: $('.graduates-list-item'),
                emptyState: $('.graduates-list-no-results'),
                categories: $('.graduates-categories-list-item-link')
            };
    	}
    
        initEvents () {
            this.UI.input.on('input', () => {
                let phrase = this.UI.input.val().toLowerCase();
                let founded = false;
    
                this.deactivateCategory();
    
                if (phrase.trim() === '') {
                    this.UI.items.removeClass('is-hidden');
                    this.UI.emptyState.addClass('is-hidden');
                    return;    
                }
    
                this.UI.items.addClass('is-hidden');
                
                for (let i = 0; i < this.UI.items.length; i++) {
                    if (this.UI.items.eq(i).attr('data-search').indexOf(phrase) > -1) {
                        this.UI.items.eq(i).removeClass('is-hidden');
                        founded = true;
                    }
                }
    
                if (founded) {
                    this.UI.emptyState.addClass('is-hidden');
                } else {
                    this.UI.emptyState.removeClass('is-hidden');
                }
            });
    
            this.UI.categories.on('click', (e) => {
                e.preventDefault();
                this.UI.input.val('');
                this.UI.items.addClass('is-hidden');
                this.UI.categories.removeClass('is-active');
                let founded = false;
                let categoryName = $(e.target).attr('data-category');
                $(e.target).addClass('is-active');
    
                for (let i = 0; i < this.UI.items.length; i++) {
                    if (this.UI.items.eq(i).attr('data-categories').indexOf('|' + categoryName + '|') > -1) {
                        this.UI.items.eq(i).removeClass('is-hidden');
                        founded = true;
                    }
                }
    
                if (founded) {
                    this.UI.emptyState.addClass('is-hidden');
                } else {
                    this.UI.emptyState.removeClass('is-hidden');
                }
            });
        }
    
        deactivateCategory () {
            this.UI.categories.removeClass('is-active');
            this.UI.items.removeClass('is-hidden');
            this.UI.emptyState.addClass('is-hidden');
        }
    }
    
    /**
     * UTM -> window.ppUtmData helper
     */
    class PP_UTM {
    	constructor() {
        this.utmResults = {
          'utm_content': null,
          'utm_campaign': null,
          'utm_medium': null,
          'utm_source': null,
          'gclid': null
        };
    
        window.ppUtmData = window.ppUtmData || {};
    
        this.parseUtmsInUrl();
        this.setReferrer();
        this.setUtmData();
      }
    
      parseUtmsInUrl () {
        let query = window.location.href;
              
        if (query.indexOf('?') != -1){
          query = query.split('?');		
          query = query[1];
        }
    
        let parsedQuery = query.split("&");
        let allowedKeys = Object.keys(this.utmResults);
    
        for (var i = 0; i < parsedQuery.length; i++) {
          let pair = parsedQuery[i].split('=');
          let key = decodeURIComponent(pair[0]);
    
          if (key.length === 0 || allowedKeys.indexOf(key) === -1) {
            continue;
          }
    
          let value = decodeURIComponent(pair[1].replace("+"," "));
          this.utmResults[key] = value;
        }
      };
    
      setReferrer () {
        this.utmResults.referrer = document.referrer;
    
        if (!!this.utmResults.referrer) {
          this.utmResults.referrer = this.utmResults.referrer.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
          this.utmResults.referrer = this.utmResults.referrer.replace(/[^a-z0-9\-\_\.\/\+\@\?\&ąćęłńóśźż]/gmi, '');
        } else {
          this.utmResults.referrer = null;
        }
    
        if (this.utmResults.referrer === window.location.host) {
          this.utmResults.referrer = null;
        }
      }
    
      setUtmData () {
        // UTM SOURCE
        if (this.utmResults.utm_source !== null) {
          window.ppUtmData.utm_source = this.utmResults.utm_source;
        } else if (this.utmResults.gclid !== null) {
          window.ppUtmData.utm_source = 'google';
        } else if (!window.ppUtmData.utm_source && this.utmResults.referrer !== null) {
          window.ppUtmData.utm_source = this.utmResults.referrer;
          window.ppUtmData.utm_medium = 'referral';
        }
    
        // UTM MEDIUM
        if (this.utmResults.utm_medium !== null) {
          window.ppUtmData.utm_medium = this.utmResults.utm_medium;
        } else if (this.utmResults.gclid !== null) {
          window.ppUtmData.utm_medium = 'cpc';
        }
    
        // UTM CAMPAIGN
        if (this.utmResults.utm_campaign !== null) {
          window.ppUtmData.utm_campaign = this.utmResults.utm_campaign;
        }
    
        // UTM CONTENT
        if (this.utmResults.utm_content !== null) {
          window.ppUtmData.utm_content = this.utmResults.utm_content;
        }
      }
    }
    
    /**
     * Cookie Banner
     */
    
    /*
     Connections:
     -------------------------------------------------------------------------------
     * players - every player on website: YouTube, Vimeo
     * google - Google Ads
     * marketing - chat, Convertbox
     * clarity - Microsoft Clarity
     * facebook - Meta Pixel
     * abtests - VWO
     * 
    */
    
    (function ($) {
      var config = {
          debugMode: true,
          userConsents: {
              players: false,
              google: false,
              marketing: false,
              clarity: false,
              facebook: false,
              abtests: false
          },
          userUUID: 'not-set',
          groups: [
              'players',
              'google',
              'marketing',
              'clarity',
              'facebook',
              'abtests'
          ],
          allowedGroups: []
      };
    
      var UI = {
          basicWindow: $('.pp-cn-info'),
          extendedWindow: $('.pp-cn-info-extended'),
          buttons: {
              basicShowExtended: $('.pp-cn-info-button-show-extended'),
              basicAcceptAll: $('.pp-cn-info-button-accept-all'),
              basicRejectAll: $('.pp-cn-info-button-reject-all'),
              extendedAcceptAll: $('.pp-cn-info-extended-button-accept-all'),
              extendedSaveConfig: $('.pp-cn-info-extended-button-save-consent'),
              extendedNotNow: $('.pp-cn-info-extended-button-close-without-save')
          },
          checkboxes: {
              players: $('.pp-cn-consent-checkbox[data-consent-type="players"]'),
              google: $('.pp-cn-consent-checkbox[data-consent-type="google"]'),
              marketing: $('.pp-cn-consent-checkbox[data-consent-type="marketing"]'),
              clarity: $('.pp-cn-consent-checkbox[data-consent-type="clarity"]'),
              facebook: $('.pp-cn-consent-checkbox[data-consent-type="facebook"]'),
              abtests: $('.pp-cn-consent-checkbox[data-consent-type="abtests"]')
          }
      };
    
      if (UI.basicWindow.length) {
          initEvents();
          initPublicAPI();
          checkConfig(config);
      }
    
      function checkConfig () {
          var configFromCookie = Cookies.get(window.ppCNConfig.cookieName, { path: window.ppCNConfig.path });
    
          // When no config - show popup
          if (!configFromCookie) {
              if (config.debugMode) {
                  console.log('⛔️ Consent config not found - showing popup');
              }
      
              config.userUUID = generateUUID();
              showPopup();
              return;
          }
    
          // otherwise - load config without showing popup
          loadConfig(configFromCookie);
      }
    
      function loadConfig (configFromCookie) {
          config.userConsents.players = configFromCookie.indexOf('players') > -1;
          config.userConsents.google = configFromCookie.indexOf('google') > -1;
          config.userConsents.marketing = configFromCookie.indexOf('marketing') > -1;
          config.userConsents.clarity = configFromCookie.indexOf('clarity') > -1;
          config.userConsents.facebook = configFromCookie.indexOf('facebook') > -1;
          config.userConsents.abtests = configFromCookie.indexOf('abtests') > -1;
          let configParts = configFromCookie.split('||');
    
          if (configParts[1]) {
              config.userUUID = configParts[1].replace(/[^a-zA-Z0-9\-]/gmi, '');
          } else {
              config.userUUID = generateUUID();
          }
    
          for (var i = 0; i < config.groups.length; i++) {
              var groupName = config.groups[i];
    
              if (config.userConsents[groupName]) {
                  config.allowedGroups.push(groupName);
              }
          }
    
          if (config.debugMode) {
              console.log('⚙️ Founded config:', JSON.parse(JSON.stringify(config.userConsents)));
          }
      }
    
      function initEvents () {
          $(document).find('a[href="#cookie-settings"]').on('click', e => {
              e.preventDefault();
              showExtendedPopup();
          });
    
          UI.buttons.basicShowExtended.on('click', e => {
              e.preventDefault();
              closePopup();
              showExtendedPopup();
          });
    
          UI.buttons.basicAcceptAll.on('click', e => {
              e.preventDefault();
              giveConsentForAll();
              closePopup();
          });
    
          UI.buttons.basicRejectAll.on('click', e => {
              e.preventDefault();
              resetCookieConfig();
              closePopup();
          });
    
          UI.buttons.extendedAcceptAll.on('click', e => {
              e.preventDefault();
              giveConsentForAll();
              closeExtendedPopup();
          });
    
          UI.buttons.extendedSaveConfig.on('click', e => {
              e.preventDefault();
              saveConsent();
              closeExtendedPopup();
          });
    
          UI.buttons.extendedNotNow.on('click', e => {
              e.preventDefault();
              closeExtendedPopup();
          });
      }
    
      function setCheckboxes () {
          for (var i = 0; i < config.groups.length; i++) {
              var group = config.groups[i];
    
              if (config.userConsents[group]) {
                  UI.checkboxes[group].prop('checked', true);
              } else {
                  UI.checkboxes[group].prop('checked', false);
              }
          }
      }
    
      function initPublicAPI () {
          window.ppCookieBanner = {
              giveConsentAndSave: function (type) {
                  giveConsentAndSave(type);
              },
              giveConsentAndSaveAndLoad: function (type) {
                  giveConsentAndSave(type, true);
              },
              showExtendedPopup: function () {
                  showExtendedPopup();
              },
              getConsentStatus: function (type) {
                  getConsentStatus(type);
              }
          };
      }
    
      function showPopup () {
          UI.basicWindow.removeClass('is-hidden');
      }
    
      function closePopup () {
          UI.basicWindow.addClass('is-hidden');
      }
    
      function showExtendedPopup () {
          UI.extendedWindow.removeClass('is-hidden');
          $(document.body).addClass('no-scroll');
          setCheckboxes();
      }
    
      function closeExtendedPopup () {
          UI.extendedWindow.addClass('is-hidden');
          $(document.body).removeClass('no-scroll');
      }
    
      function giveConsentForAll () {
          giveConsent('players');
          giveConsent('google');
          giveConsent('marketing');
          giveConsent('clarity');
          giveConsent('facebook');
          giveConsent('abtests');
          saveConsentConfigInCookie(false);
      }
    
      function giveConsent (type, forceOnLoad = false) {
          if (config.debugMode) {
              console.log('✅ User gave consent:', type);
          }
    
          // If consent has been previously given - do nothing
          if (config.allowedGroups.indexOf(type) > -1) {
              return;
          }
    
          config.userConsents[type] = true;
    
          if (type === 'players') {
              allowPlayers();
              return;
          }
    
          if (type === 'google') {
              allowGoogle();
              return;
          }
    
          if (type === 'marketing') {
              allowMarketing();
              return;
          }
    
          if (type === 'clarity') {
            allowClarity();
            return;
          }
    
          if (type === 'facebook') {
            allowFB();
            return;
          }
    
          if (type === 'abtests') {
            allowABTests();
            return;
          }
      }
    
      function giveConsentAndSave (type, forceOnLoad = false) {
          giveConsent(type, forceOnLoad);
          saveConsentConfigInCookie(false);
      }
    
      function saveConsent () {
          var consentCompare = compareConsents();
          setConsentBasedOnCheckboxes();
    
          // if some consent has been removed
          if (consentCompare === 'some-rejected') {
              saveConsentConfigInCookie(true);
              return;
          }
    
          // otherwise - if some consent has been added
          saveConsentConfigInCookie(false);
      }
    
      function setConsentBasedOnCheckboxes () {
          for (var i = 0; i < config.groups.length; i++) { 
              var group = config.groups[i];
    
              if (!!UI.checkboxes[group].prop('checked')) {
                  giveConsent(group);
              }
    
              config.userConsents[group] = !!UI.checkboxes[group].prop('checked');
          }
      }
    
      function saveConsentConfigInCookie (reloadNeeded = false) {
          var configToSave = [];
    
          for (var i = 0; i < config.groups.length; i++) {
              var group = config.groups[i];
    
              if (config.userConsents[group]) {
                  configToSave.push(group);
              }
          }
    
          if (configToSave.length) {
              Cookies.set(window.ppCNConfig.cookieName, configToSave.join(';') + '||' + config.userUUID, { expires: 180, path: window.ppCNConfig.path });
    
              if (config.debugMode) {
                  console.log('🍪 Consent config saved in the cookie');
              }
          } else {
              Cookies.set(window.ppCNConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.ppCNConfig.path });
          }
    
          let dataToSave = {
              consent_id: config.userUUID,
              consent_revision: window.ppCNConfig.cookieName,
              consent_content: configToSave.join(';'),
              consent_timestamp: +new Date(),
              url: window.location.pathname,
              delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
          };
        
          if ('sendBeacon' in navigator) {
              const formData = $.param(dataToSave);
              const blob = new Blob(
              [formData], 
              {
                  type : 'application/x-www-form-urlencoded'
              }
              );
              navigator.sendBeacon('https://podcastpro.pl/wp-json/cmp/v1/save', blob);
              
              if (reloadNeeded) {
                  setTimeout(() => {
                      window.location.reload();
                  }, 500);
              }
          } else {
              $.ajax({
              url: 'https://podcastpro.pl/wp-json/cmp/v1/save',
              type: 'POST',
              contentType: 'application/x-www-form-urlencoded',
              data: $.param(dataToSave),
              success: function () {
                  if (reloadNeeded) {
                      setTimeout(() => {
                          window.location.reload();
                      }, 500);
                  }
              },
              fail: function () {
                  if (reloadNeeded) {
                      setTimeout(() => {
                          window.location.reload();
                      }, 500);
                  }
              }
              });
          }
      }
    
      function resetCookieConfig () {
          Cookies.set(window.ppCNConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.ppCNConfig.path });
    
          if (config.debugMode) {
            console.log('🗑 User rejected all cookies - save empty config cookie');
          }
    
          let dataToSave = {
            consent_id: config.userUUID,
            consent_revision: window.ppCNConfig.cookieName,
            consent_content: '',
            consent_timestamp: +new Date(),
            url: window.location.pathname,
            delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
          };
      
          if ('sendBeacon' in navigator) {
              const formData = $.param(dataToSave);
              const blob = new Blob(
                [formData], 
                {
                    type : 'application/x-www-form-urlencoded'
                }
              );
              navigator.sendBeacon('https://podcastpro.pl/wp-json/cmp/v1/save', blob);
          } else {
              $.ajax({
                url: 'https://podcastpro.pl/wp-json/cmp/v1/save',
                type: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: $.param(dataToSave)
              });
          }
      }
    
      function compareConsents () {
          var someRejected = false;
    
          for (var i = 0; i < config.groups.length; i++) {
              var group = config.groups[i];
    
              if (config.userConsents[group] && !UI.checkboxes[group].prop('checked')) {
                  someRejected = true;
    
                  if (group === 'google' && typeof gtag === 'function') {
                      gtag('consent', 'update', {
                          ad_user_data: 'denied',
                          ad_personalization: 'denied',
                          ad_storage: 'denied',
                          analytics_storage: 'denied'
                      });
                  }
    
                  if (group === 'clarity' && typeof window.clarity === 'function') {
                      window.clarity('consentv2', {
                          ad_Storage: 'denied',
                          analytics_Storage: 'denied'
                      });
                  }
              }
          }
    
          if (someRejected) {
              if (config.debugMode) {
                  console.log('🔄 Some consents has been rejected - website reload needed');
              }
    
              return 'some-rejected';
          }
    
          if (config.debugMode) {
              console.log('ℹ️ User not rejected any consents - website reload not needed');
          }
    
          return 'some-added-or-not-changed';
      }
    
      function getConsentStatus (type) {
          return !!config.userConsents[type];
      }
    
      function allowPlayers () {
          if (window.ppUnlocked.indexOf('players') > -1) {
              return;
          }
    
          window.ppUnlockPlayers(true);
      }
    
      function allowGoogle () {
          if (window.ppUnlocked.indexOf('google') > -1) {
              return;
          }
    
          window.ppUnlockConsentedScript('google', 'head', true);
      }
    
      function allowMarketing () {
          if (window.ppUnlocked.indexOf('marketing') > -1) {
              return;
          }
    
          window.ppUnlockConsentedScript('marketing', 'head', true);
          window.ppUnlockMarketing(true);
      }
    
      function allowClarity () {
        if (window.ppUnlocked.indexOf('clarity') > -1) {
            return;
        }
    
        window.ppUnlockConsentedScript('clarity', 'head', true);
      }
    
      function allowFB () {
        if (window.ppUnlocked.indexOf('facebook') > -1) {
            return;
        }
    
        window.ppUnlockConsentedScript('facebook', 'head', true);
      }
    
      function allowABTests () {
        if (window.ppUnlocked.indexOf('abtests') > -1) {
            return;
        }
    
        window.ppUnlockConsentedScript('abtests', 'head', true);
      }
    
      function generateUUID () {
          var crypto = window.crypto || window.msCrypto;
    
          if (crypto && crypto.randomUUID) {
              let uuid = crypto.randomUUID();
              return uuid;
          }
    
          if (window.Uint8Array && crypto && crypto.getRandomValues) {
              let bytes = new Uint8Array(16);
              crypto.getRandomValues(bytes);
              bytes[6] = (bytes[6] & 0x0f) | 0x40;
              bytes[8] = (bytes[8] & 0x3f) | 0x80;
              let uuid = Array.prototype.map.call(bytes, (b, i) => {
                  return ((b < 16) ? '0' : '') + b.toString(16) + (((i % 2) && (i < 10) && (i > 2)) ? "-" : "");
              }).join('');
              return uuid;
          }
    
          var dt = new Date().getTime();
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
              var r = (dt + Math.random()*16)%16 | 0;
              dt = Math.floor(dt/16);
              return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
          });
    
          return uuid;
      }
    })(jQuery);
    
    class PP_Newsletter {
      constructor () {
          if (!$('.pp-newsletter-form, .wpcf7, .encharge-form').length) {
              return;
          }
    
          this.readUtmFromCookies();
      }
    
      readUtmFromCookies () {
          let forms = $('.pp-newsletter-form, .wpcf7, .encharge-form');
          
          if (!forms.length) {
              return;
          }
    
          let utmSource = window.ppUtmData.utm_source;
          let utmMedium = window.ppUtmData.utm_medium;
          let utmCampaign = window.ppUtmData.utm_campaign;
          let utmContent = window.ppUtmData.utm_content;
    
          for (let i = 0; i < forms.length; i++) {
            let form = forms.eq(i);
            
            if (utmSource) {
                form.find('input[name="utm_source"]').val(utmSource);
                form.find('input.enchagre-form-v2[name="UTMSource"]').val(utmSource);
            }
    
            if (utmMedium) {
                form.find('input[name="utm_medium"]').val(utmMedium);
                form.find('input.enchagre-form-v2[name="UTMMedium"]').val(utmMedium);
            }
    
            if (utmCampaign) {
                form.find('input[name="utm_campaign"]').val(utmCampaign);
                form.find('input.enchagre-form-v2[name="UTMCampaign"]').val(utmCampaign);
            }
    
            if (utmContent) {
                form.find('input[name="utm_content"]').val(utmContent);
                form.find('input.enchagre-form-v2[name="UTMContent"]').val(utmContent);
            }
          }
      }
    }
    
    
    new PP_UTM();
    new PP_Menu();
    new PP_UI();
    new PP_SocialSharing();
    new PP_BlogCategories();
    new PP_Graduates();
    new PP_Newsletter();
})(jQuery);
